import { render, staticRenderFns } from "./DeleteFolderModal.vue?vue&type=template&id=28d64e3e&"
import script from "./DeleteFolderModal.vue?vue&type=script&lang=js&"
export * from "./DeleteFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports